<template>
  <v-card>
    <v-toolbar color="secondary">
      <v-toolbar-title class="white--text"
        >Visualização do preço combustíveis</v-toolbar-title
      >
    </v-toolbar>
    <v-card-text class="headline" style="text-align: center;">
      A configuração desse recurso é de total responsabilidade do posto sobre
      como os clientes ficarão informados do preço dos combustíveis cadastrados
      através da Apetrus.

      <v-radio-group v-model="posto.mostrar_precos" column>
        <v-radio
          label="DESATIVADO: Nenhum usuário terá acesso aos preços, mas ainda visualizam o desconto."
          value="0"
        ></v-radio>
        <v-radio
          label="TODOS: Qualquer usuário poderá visualizar os preços e descontos."
          value="1"
        ></v-radio>
        <v-radio
          label="GEOLOCALIZAÇÃO: Usuários visualizarão os preços e descontos somente estando na área do posto."
          value="2"
        ></v-radio>
        <v-radio
          label="CLIENTES: Apenas clientes do posto que realizaram ao menos uma compra poderão visualizar os preços e descontos."
          value="3"
        ></v-radio>
      </v-radio-group>
      <v-btn @click="salvarVisualizacao" class="mt-3" block color="primary"
        >Salvar visualização</v-btn
      >
    </v-card-text>
  </v-card>
</template>

<script>
import { postosDao } from '@/api'

export default {
  data: () => ({
    teste: 1
  }),
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  mounted () {
    this.posto.mostrar_precos = this.posto.mostrar_precos.toString()
  },
  methods: {
    mostrarPrecos () {
      postosDao.mostrarPrecos(this.headers, this.posto.cnpj).then(response => {
        if (!response.ok) {
          return
        }
        this.$store.dispatch('escolherPosto', { cnpj: this.posto.cnpj })
        this.$emit('carregar')
        this.$emit('fechar')
      })
    },
    salvarVisualizacao () {
      const data = { tipo: this.posto.mostrar_precos }
      postosDao
        .mostrarPrecos(this.headers, this.posto.cnpj, data)
        .then((response) => {
          if (!response.ok) {
            return
          }
          this.$emit('fechar')
        })
    }
  }
}
</script>
